import Glightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'
import './Styles.scss'

export { Glightbox }

// HTML content
const htmlPopup = () => {
    const popups = document.querySelectorAll('.glightbox')

    if (popups) {
        let i = 0;
        popups.forEach(popup => {
            i++;

            let popupId = 'glightbox-' + i
            popup.classList.add(popupId)

            const lightbox = Glightbox({
                selector:        '.' + popupId,
                height:          'auto',
                draggable:       false,
                closeButton:     false,
                touchNavigation: false,
                loop:            false
            })

            lightbox.on('open', () => {
                document.getElementsByClassName('gnext')[0].remove()
                document.getElementsByClassName('gprev')[0].remove()

                const customCloseButton = document.querySelectorAll('.popup__close')

                if (customCloseButton) {
                    customCloseButton.forEach(closeButton => {
                        closeButton.addEventListener('click', () => {
                            lightbox.close()
                        })
                    })
                }
            })
        })
    }
}

htmlPopup()